const benefits = [
  {
    icon: 'ri-time-line',
    title: 'Save Time Finding Products',
    desc: 'Skip endless browsing. Our kakobuy spreadsheet organizes thousands of listings into clean, searchable categories so you find what you need in seconds.',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20desk%20workspace%20with%20organized%20spreadsheet%20and%20product%20cards%20neatly%20arranged%20on%20light%20oak%20wooden%20surface%20warm%20morning%20sunlight%20streaming%20through%20window%20creating%20productive%20calm%20atmosphere%20editorial%20photography%20clean%20modern%20aesthetic&width=500&height=350&seq=kakobuy-why-save-time&orientation=landscape',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Compare Trusted Sellers',
    desc: 'Every seller in the kakobuyspreadsheet database is vetted through community feedback and verified transaction history.',
    image: 'https://readdy.ai/api/search-image?query=Two%20product%20cards%20side%20by%20side%20with%20rating%20stars%20and%20detailed%20comparison%20metrics%20displayed%20on%20soft%20sage%20green%20linen%20fabric%20surface%20natural%20diffused%20lighting%20editorial%20style%20trust%20and%20verification%20concept%20modern%20elegant%20composition&width=500&height=350&seq=kakobuy-why-trusted-sellers&orientation=landscape',
  },
  {
    icon: 'ri-fire-line',
    title: 'Discover Popular Brands',
    desc: 'From streetwear essentials to luxury finds, the best kakobuy spreadsheet reveals trending items before they go viral.',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20brand%20logos%20and%20trending%20fashion%20items%20arranged%20as%20a%20moodboard%20on%20polished%20concrete%20grey%20surface%20with%20warm%20accent%20lighting%20creative%20editorial%20composition%20conveying%20discovery%20and%20excitement%20modern%20aesthetic&width=500&height=350&seq=kakobuy-why-discover-brands&orientation=landscape',
  },
  {
    icon: 'ri-alarm-warning-line',
    title: 'Avoid Unreliable Listings',
    desc: 'Our kakobuy spreadsheet flags suspicious sellers and outdated links so you never waste money on dead-end purchases.',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20interface%20showing%20a%20red%20flag%20warning%20icon%20beside%20a%20crossed-out%20product%20listing%20on%20light%20warm%20grey%20matte%20surface%20soft%20daylight%20editorial%20photography%20concept%20of%20consumer%20protection%20and%20smart%20shopping%20minimalist%20composition&width=500&height=350&seq=kakobuy-why-avoid-scams&orientation=landscape',
  },
  {
    icon: 'ri-link-m',
    title: 'Access Updated Links',
    desc: 'Links in our kakobuy spreadsheet are refreshed daily. No more dead URLs or sold-out disappointments.',
    image: 'https://readdy.ai/api/search-image?query=Sleek%20digital%20interface%20displaying%20refresh%20icon%20and%20connected%20link%20chains%20on%20soft%20peach%20toned%20matte%20surface%20gentle%20morning%20light%20editorial%20photography%20concept%20of%20connectivity%20and%20real-time%20updates%20modern%20clean%20aesthetic&width=500&height=350&seq=kakobuy-why-updated-links&orientation=landscape',
  },
];

export default function WhySection() {
  return (
    <section id="why" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wide uppercase mb-4">
            / Why KakobuySpreadsheet
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 leading-tight">
            Why Use <span className="text-primary-600">Kakobuy Spreadsheet</span>?
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto mt-4 leading-relaxed">
            The <strong>kakobuyspreadsheet</strong> platform is built by buyers, for buyers. Unlike generic review sites, our approach combines real spreadsheet data with hands-on verification to give you a complete picture before every purchase.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((item) => (
            <div
              key={item.title}
              className="group rounded-2xl overflow-hidden bg-background-100 border border-background-200/70 transition-all duration-300 hover:border-primary-200"
            >
              <div className="w-full h-[200px] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-3 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-300">
                  <i className={`${item.icon} text-lg`}></i>
                </span>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}